import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import BranchMixin, { BranchMixinDefaultValues, branchFromJSON } from 'automation-ui-action-features/records/BranchMixin';
const StaticBranchDefaultValues = Object.assign({}, BranchMixinDefaultValues, {
  value: undefined,
  propertyValue: null,
  operator: 'IS_EQUAL_TO'
});
/**
 * A StaticBranch represents a single branch of a Static Branch action
 *
 * The 'value' is used as the branch name, and the `propertyValue`
 * is the PropertyValue record associated with the branch
 */
class StaticBranch extends BranchMixin(createImmutableObjectClass(StaticBranchDefaultValues, {
  fromJSON: json => Object.assign({}, json, branchFromJSON(json)),
  toJSON: branch => branch
})) {
  getBranchName() {
    return this.getValue() || '';
  }
  setBranchName(branchName) {
    return this.set('value', branchName);
  }
  getValue() {
    var _this$value$toString, _this$value;
    return (_this$value$toString = (_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.toString()) !== null && _this$value$toString !== void 0 ? _this$value$toString : '';
  }
}
export default StaticBranch;